import React, { memo, useEffect } from "react";
import ErrorModal from "~/components/modals/error/ErrorModal";
import s from "~/components/modals/error/ErrorModal.module.scss";
import { logEvent } from "~/utils/amplitude";

interface Props {
  isError: boolean;
  onClose: () => void;
}

const ErrorNotAbleToAssign: React.FC<Props> = memo(({ isError, onClose }) => {
  const handleClose = () => {
    logEvent("Д/ Нажал кнопку Закрыть / Ошибка авторизации");
    onClose();
  };

  const handleConfirm = () => {
    logEvent("Д/ Нажал кнопку Сообщить о проблеме / Ошибка авторизации");
  };

  return (
    <ErrorModal
      onClose={handleClose}
      onConfirm={handleConfirm}
      width={510}
      isOpened={isError}
    >
      <div className={s.errorAssign}>
        <p>Не удалось найти пациента с такими данными.</p>
        <p>Возможно вы:</p>
        <ol>
          <li>Не прикреплены к данном поликлинике.</li>
          <li>Сменили полис.</li>
          <li>Неверно внесли свои данные.</li>
        </ol>
      </div>
    </ErrorModal>
  );
});

ErrorNotAbleToAssign.displayName = "ErrorNotAbleToAssign";

export default ErrorNotAbleToAssign;
